export default __webpack_public_path__ + "static/media/catTag.5e57776b.svg";